<div *ngIf="data?.asOfDate;else noData">
  <div style="display: flex;">
    <p class="disclaimer rps-grey rps-paragraph-two" data-rpa-tag-id="cumulativeDate">as of {{ data?.asOfDate | ESTPipe
      | DashIfEmpty }}</p>
  </div>
  <div style="position: relative;">
    <div class="table-container">
      <table scrollingTable aria-label="Performance cumulative">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">1-yr</th>
            <th scope="col">3-yr</th>
            <th scope="col">5-yr</th>
            <th scope="col">10-yr</th>
            <th scope="col">
              <p style="white-space: nowrap;">Since inception</p>
              <p data-rpa-tag-id="inceptionDate">{{ data?.sinceInceptionAsOfDate | ESTPipe | DashIfEmpty }}</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="profileData?.isETF">
            <th scope="col">{{profileData?.ticker | DashIfEmpty }} (Market price)</th>
            <td scope="col" data-rpa-tag-id="oneYrPctMarket">{{data?.marketPriceFundReturn?.oneYrPct | VMFPercent |
              DashIfEmpty }}</td>
            <td scope="col" data-rpa-tag-id="threeYrPctMarket">{{data?.marketPriceFundReturn?.threeYrPct | VMFPercent |
              DashIfEmpty }}</td>
            <td scope="col" data-rpa-tag-id="fiveYrPctMarket">{{data?.marketPriceFundReturn?.fiveYrPct | VMFPercent |
              DashIfEmpty }}</td>
            <td scope="col" data-rpa-tag-id="tenYrPctMarket">{{data?.marketPriceFundReturn?.tenYrPct | VMFPercent |
              DashIfEmpty }}</td>
            <td scope="col" data-rpa-tag-id="inceptionPercentageMarket">{{data?.marketPriceFundReturn?.sinceInceptionPct
              | VMFPercent | DashIfEmpty }}</td>
          </tr>
          <tr>
            <th scope="col" *ngIf="profileData?.isETF">{{profileData?.ticker | DashIfEmpty }} (NAV)</th>
            <th scope="col" *ngIf="!profileData?.isETF">{{profileData?.is529 ? profileData?.shortName :
              profileData?.ticker | DashIfEmpty}}<sup
                *ngIf="profileData?.ticker=='VPGDX'">{{performanceFootNote?.id}}</sup></th>
            <td scope="col" data-rpa-tag-id="oneYrPctFund">{{data?.fundReturn?.oneYrPct | VMFPercent | DashIfEmpty }}
            </td>
            <td scope="col" data-rpa-tag-id="threeYrPctFund">{{data?.fundReturn?.threeYrPct | VMFPercent | DashIfEmpty
              }}</td>
            <td scope="col" data-rpa-tag-id="fiveYrPctFund">{{data?.fundReturn?.fiveYrPct | VMFPercent | DashIfEmpty }}
            </td>
            <td scope="col" data-rpa-tag-id="tenYrPctFund">{{data?.fundReturn?.tenYrPct | VMFPercent | DashIfEmpty }}
            </td>
            <td scope="col" data-rpa-tag-id="inceptionPercentageFund">{{data?.fundReturn?.sinceInceptionPct | VMFPercent
              | DashIfEmpty }}</td>
          </tr>
          <tr>
            <th scope="col">
              <p>
                <label>Benchmark<sup *ngIf="benchmarkFootNote?.text">{{benchmarkFootNote?.id}}</sup></label>
                <c11n-tooltip [autoOrientation]="false" colorMode="on-light" class="inner-align" [direction]="isSmallScreen ? 'right' : 'above'" labelText="Benchmark">
                  <span c11nTooltipContent>{{ data?.benchmarkReturn?.name || '(Benchmark)' }}</span>
                </c11n-tooltip>
              </p>
            </th>
            <td scope="col" data-rpa-tag-id="oneYrPctBenchmrk">{{data?.benchmarkReturn?.oneYrPct | VMFPercent}}</td>
            <td scope="col" data-rpa-tag-id="threeYrPctBenchmrk">{{data?.benchmarkReturn?.threeYrPct | VMFPercent}}</td>
            <td scope="col" data-rpa-tag-id="fiveYrPctBenchmrk">{{data?.benchmarkReturn?.fiveYrPct | VMFPercent}}</td>
            <td scope="col" data-rpa-tag-id="tenYrPctBenchmrk">{{data?.benchmarkReturn?.tenYrPct | VMFPercent}}</td>
            <td scope="col" data-rpa-tag-id="inceptionPercentageBenchmrk">{{data?.benchmarkReturn?.sinceInceptionPct |
              VMFPercent}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #noData>
  <p class="disclaimer rps-paragraph-one" *ngIf="!data?.asOfDate" class='no-data'>This information is temporarily
    unavailable.</p>
</ng-template>
